import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../../common/GlobalFunctions";
export const AddTicketColumns: GridColDef[] = [
  {
    field: "id",
    headerName: "Id",
    type: "string",
    editable: false,
  },
  {
    field: "title",
    headerName: "Title",
    type: "string",
    editable: false,
  },
  {
    field: "assetActionTypeId",
    headerName: "AssetActionTypeId",
    type: "string",
    editable: false,
  },
  {
    field: "assetActionType",
    headerName: "AssetActionTypes",
    type: "string",
    editable: false,
    renderCell: ({ row }) => (
      <span>{row.assetActionType ? row.assetActionType.title : ""}</span>
    ),
  },
  {
    field: "amount",
    headerName: "Amount",
    type: "number",
    editable: false,
  },
  {
    field: "date",
    headerName: "Date",
    type: "date",
    editable: false,
    valueFormatter: formatDate,
  },
  {
    field: "description",
    headerName: "Description",
    type: "string",
    editable: false,
  },
];
